/*
 * Copyright (c) 2024. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import type { AbsoluteURL, PANotification, PrefectFlow } from '@poweralpha/common';
import type { UINotificationsQueryResult } from './Notifications';

export const toastAutoClose = 10e3;

export const notLoadedDefault: UINotificationsQueryResult = {
  unread: [],
  count: 0,
  rows: [],
};

export const componentCreationFlows: Array<PrefectFlow> = ['Add Price Curves'];

export const componentCreationFlowToBaseUrls: Partial<Record<PrefectFlow, AbsoluteURL>> = {
  'Add Price Curves': '/db/prices',
};

export const componentCreationFlowToDetailUrls: Partial<
  Record<PrefectFlow, (n: PANotification) => AbsoluteURL>
> = {
  'Add Price Curves': (n) =>
    n.meta.prices_type ? `/db/prices/${n.meta.prices_type}/` : '/db/prices',
};
